// CLIENT page registry — lazy chunks keep blog/guide content and heavy pages out of main.js.
// The prerender build aliases this module to pageRegistry.static.js (sync imports) so
// renderToString keeps working. Keep both files' export lists identical.
import { lazy } from "react";

const pick = (loader, name) => lazy(() => loader().then((m) => ({ default: m[name] })));

export const HomePage = lazy(() => import("@/pages/HomePage"));
export const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
export const ServiceHub = lazy(() => import("@/pages/ServiceHub"));
export const PricingPage = lazy(() => import("@/pages/PricingPage"));
export const FaqPage = lazy(() => import("@/pages/FaqPage"));
export const PrivacyPage = pick(() => import("@/pages/LegalPages"), "PrivacyPage");
export const TermsPage = pick(() => import("@/pages/LegalPages"), "TermsPage");
export const WorkPage = pick(() => import("@/pages/WorkPages"), "WorkPage");
export const ProjectPage = pick(() => import("@/pages/WorkPages"), "ProjectPage");
export const ReviewsPage = lazy(() => import("@/pages/ReviewsPage"));
export const AboutPage = lazy(() => import("@/pages/AboutPage"));
export const ContactPage = lazy(() => import("@/pages/ContactPage"));
export const ResourcesPage = pick(() => import("@/pages/ResourceIndexes"), "ResourcesPage");
export const GuidesPage = pick(() => import("@/pages/ResourceIndexes"), "GuidesPage");
export const BlogPage = pick(() => import("@/pages/ResourceIndexes"), "BlogPage");
export const ResourceArticle = pick(() => import("@/pages/ResourceArticle"), "ResourceArticle");
export const LegacyPostPage = pick(() => import("@/pages/ResourceArticle"), "LegacyPostPage");
export const CheckoutPage = pick(() => import("@/pages/CheckoutPages"), "CheckoutPage");
export const CheckoutSuccessPage = pick(() => import("@/pages/CheckoutPages"), "CheckoutSuccessPage");
export const CheckoutCancelPage = pick(() => import("@/pages/CheckoutPages"), "CheckoutCancelPage");
export const StartPage = pick(() => import("@/pages/CheckoutPages"), "StartPage");
export const MarketingFitPage = lazy(() => import("@/pages/MarketingFitPage"));
export const OnSiteContentPage = lazy(() => import("@/pages/OnSiteContentPage"));
export const FreeContentIdeasPage = lazy(() => import("@/pages/FreeContentIdeasPage"));
export const SpeakingPage = lazy(() => import("@/pages/SpeakingPage"));
export const StubPage = lazy(() => import("@/pages/StubPage"));
export const HudsonChat = pick(() => import("@/components/HudsonChat"), "HudsonChat");
